export const DEFAULT_LANGUAGE = 'en';

/*  Supported languages by the widget.
 *  Check if supported by Hobex also since this values will be used also for their payment form.
*/
export const LANGUAGES = [DEFAULT_LANGUAGE, 'it', 'de'];

export const DEFAULT_DIAL_CODE = 'IT';

export const HOBEX = {
  WIDGET_FORM_ID: 'paymentWidgets',
  SUCCESSFULLY_CREATED_CHECKOUT: '000.200.100',
  TRANSACTION_SUCCEEDED: '000.000.000',
  TEST_TRANSACTION_SUCCEEDED: '000.100.110',
}

export const COMMON_COUNTRIES = ['AT', 'DE', 'IT', 'CH'];

export const DISCOUNTS = [
  {value: 20, range: '3-4'},
  {value: 30, range: '5-6'},
  {value: 40, range: '7-13'},
  {value: 50, range: '14+'}
];

export const EXCLUDED_BIKE_TYPES_HEIGHT_INSERTION = [
  12, 34 // TANDEM, E-TANDEM
];

export const EXTRA_ACCESSORIES_IN_BIKE_SELECTION_PAGE = [
  36, // Passeggino a 3 route
  37, // Passeggino gemellare
  38, // Zainetto port bimbi
];

export const ONLINE_PAYMENT_DISCOUNT = 2; // %

/*
* <i>for devs: just revert this constant when there's a change of season;</i>
* */
export const REVERT_OPENING_DAYS_PARAMS = true;

export const PAYMENT_WITH_WEBHOOKS = true;

/*
* TEST ONLY: set to true to simulate a status 0 network error (CORS/iframe blocking)
* on the getRntlPnts call (first api called), matching the real production issue. Shows the error dialog
* with a full error report. Guarded by environment.local, so it has no effect in
* staging/production. Keep this false.
* */
export const SIMULATE_RENTAL_POINTS_ERROR = false;

/*
* TEST ONLY: set to true to simulate the health endpoint failing, so the error
* dialog appears on startup without needing the backend to be down. Guarded by
* environment.local, so it has no effect in staging/production. Keep this false.
* */
export const SIMULATE_HEALTH_ERROR = false;
